import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { LogOut } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth, ROLE_LABELS } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { NAV_ITEMS, canSee } from "@/lib/nav";
import { ModeToggle } from "@/components/ModeToggle";

export function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [notif, setNotif] = useState(0);
  useEffect(() => { api.get("/notifications/unread-count").then((r) => setNotif(r.data.count)).catch(() => {}); }, [pathname]);
  const items = NAV_ITEMS.filter((i) => canSee(i, user?.role));

  return (
    <aside data-testid="app-sidebar" className="hidden md:flex sidebar-bg text-slate-100 w-64 min-h-screen flex-col flex-shrink-0 sticky top-0 h-screen">
      <div className="px-5 py-6 border-b border-white/10"><Logo onDark size="md" /></div>
      <nav className="flex-1 px-3 py-5 space-y-0.5 overflow-y-auto scrollbar-thin">
        {items.map((item) => (
          <NavLink key={item.to} to={item.to} data-testid={`sidebar-nav-${item.to.slice(1)}`}
            className={({ isActive }) => `flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-medium transition-colors ${isActive ? "bg-white/15 text-white" : "text-white/75 hover:text-white hover:bg-white/5"}`}>
            <item.icon size={18} /><span className="flex-1">{item.label}</span>
            {item.to === "/notifications" && notif > 0 && <span data-testid="sidebar-notif-count" className="text-[11px] font-bold bg-rose-500 text-white rounded-full px-1.5 min-w-[20px] text-center">{notif}</span>}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-white/10">
        <div className="flex items-center gap-3 mb-3">
          <div className="h-9 w-9 rounded-full bg-white/20 flex items-center justify-center text-white text-sm font-semibold">{user?.name?.charAt(0) || "?"}</div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium text-white truncate">{user?.name}</div>
            <div className="text-xs text-white/60 truncate">{ROLE_LABELS[user?.role] || user?.role}</div>
          </div>
          <ModeToggle className="text-white" />
        </div>
        <button data-testid="logout-button" onClick={() => { logout(); navigate("/login"); }}
          className="w-full flex items-center justify-center gap-2 rounded-lg border border-white/20 py-2 text-sm text-white hover:bg-white/10">
          <LogOut size={16} /> Sign out
        </button>
      </div>
    </aside>
  );
}
